import { ListItemButton, styled } from "@mui/material";

export const MenuBlockContainer = styled('div')(({ theme }) => ({
  width: 270,
  top: "30%", 
  left: 8, 
  position: "absolute", 
  boxShadow: `0px 2px 10px rgba(0, 0, 0, 0.2)`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  zIndex: 20
}))

export const MenuBlockHeader = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  height: 68
}))

export const MenuBlockContent = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(2)
}))

export const MenuBlockItem = styled(ListItemButton)(({ theme }) => ({
  border: 'none',
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "stretch",
  textAlign: "left",
  paddingLeft: theme.spacing(2),
  height: 54,
  width: "100%",
  fontFamily: theme.typography.fontFamily
}))

export const MenuBlockItemTitle = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 11,
  marginBottom: 4,
  fontWeight: 600
}))

export const MenuBlockItemSubTitle = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 10
}))